<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 800px; max-width: 100vw;':''">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        گروه
        <template v-slot:action>
          <q-btn icon="close" flat rounded dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-table
          flat
          row-key="Sale_Num"
          :rows-per-page-options="[0]"
          hide-pagination
          :data="details">
        <template v-slot:header>
          <q-tr class="text-bold text-center">
            <td>
              شماره فاکتور
            </td>
            <td>طرف معامله</td>
            <td>مبلغ فاکتور</td>
            <td>مبلغ دریافتی</td>
            <td>باقیمانده</td>
            <td>کل بدهی</td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="text-center">
            <td>
              <q-chip clickable @click="showFactorDetails(props.row)" square :label="props.row.Sale_Num" icon="pin"
                      color="indigo" text-color="white"/>
            </td>
            <td>
              <q-chip clickable @click="showCustomerInfo(props.row)" square :label="props.row.Cs_Name" icon="person"/>
            </td>
            <td>{{props.row.SaleG_Pay ? props.row.SaleG_Pay.toLocaleString():0 }}</td>
            <td>{{ props.row.Sale_PayReceive?props.row.Sale_PayReceive.toLocaleString():0 }}</td>
            <td>{{ props.row.DiffSalePay?props.row.DiffSalePay.toLocaleString():0 }}</td>
            <td>
              <q-chip
                  square
                  :color="props.row.RemCredit>0?'red-10':'green-10'"
                  :label="Math.abs(props.row.RemCredit).toLocaleString()"
                  text-color="white">
                <q-tooltip>
                  {{props.row.RemCredit>0?'بدهکار':'بستانکار'}}
                </q-tooltip>
              </q-chip>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-dialog :maximized="$q.screen.lt.md" v-model="customerInfoDialog">
      <CustomerInfo :dialog="true" :selected-customer="selectedCustomer"/>
    </q-dialog>
    <q-dialog maximized v-model="factorDialog">
      <FactorDetails :factor-items="factorDetails" :sale-state="1" :sale-kind="1" :sale-num="selectedSaleNum"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import CustomerInfo from "@/components/customers/CustomerInfo";
import FactorDetails from "@/components/Factor/FactorDetails";

export default {
  name: "GroupDetails",
  components: {FactorDetails, CustomerInfo},
  props: {
    groupName:{
      type:String,
      required: true
    },
    details: {
      required: true
    }
  },
  data() {
    return {
      factorDetails: [],
      factorDialog: false,
      customerInfoDialog: false,
      selectedCustomer: '',
      selectedSaleNum: ''
    }
  },
  methods: {
    ...mapActions({
      getCustomerInfo: 'Customers/get_customer_info',
      getFactorDetails: 'Orders/getFactorItems'
    }),
    showCustomerInfo(row) {
      this.getCustomerInfo(row.Cs_ID).then((res) => {
        this.selectedCustomer = res.data[0]
        this.customerInfoDialog = true
      })
    },
    showFactorDetails(row) {
      this.selectedSaleNum = row.Sale_Num
      this.getFactorDetails({
        sale_num: this.selectedSaleNum,
        sale_kind: 1
      }).then((res) => {
        this.factorDetails = res
        this.factorDialog = true;
      })
    }
  }
}
</script>

<style scoped>

</style>